import React from "react";
import theme from "../../../styles/theme";



const Page43 = () => {
  return (

    <div>
    <h2>"Page 43" </h2>
    </div>

  );
};

export default Page43;
